import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import moment from "moment";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import CardLessDataTableWithOutSearch from '../../../../components/datatables/CardLessDataTableWithOutSearch';
import PermissionDetailsModal from '../../../studentPermission/PermissionDetailsModal';
import { SectionCard, EmptyState, StatusBadge } from './naComponents';
import { THEME, GRADIENTS } from './naTheme';

// ─── GraphQL Queries (unchanged) ──────────────────────────────────────────────

const FETCH_PARENT_PERMISSION = gql`
  query($institute_id: Int!) {
    getParentsPermissionDetails(institute_id: $institute_id) {
      class_id exam_id branch_id section_id class_name exam_name branch_name section_name
      permission_id student_name roll_no student_mobile request_date from_datetime to_datetime
      receiver_name receiver_mobile request_message receiver_image_path parent_name parent_mobile
      permission_status comments approved_time approved_by outtime outtime_image_path
      outtime_inserted_by intime intime_image_path intime_inserted_by
      permission_request_type_id request_title
    }
  }
`;

const FETCH_PERMISSION_REQUEST_TYPES = gql`
  query($id: Int) {
    getPermissionRequestTypes(id: $id) {
      id
      permission_request_type
    }
  }
`;

// ─── Summary chip ─────────────────────────────────────────────────────────────

const SummaryChip = ({ label, count, bg, color }) => (
  <div style={{
    display:       'inline-flex',
    flexDirection: 'column',
    alignItems:    'center',
    background:    bg,
    color,
    borderRadius:  '12px',
    padding:       '10px 20px',
    minWidth:      '80px',
    marginRight:   '10px',
    marginBottom:  '10px',
  }}>
    <span style={{ fontSize: '22px', fontWeight: 800, lineHeight: 1 }}>{count}</span>
    <span style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '3px', opacity: 0.8 }}>{label}</span>
  </div>
);

// ─── Component ────────────────────────────────────────────────────────────────

class NAPermissionDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      viewDetailsModal:       false,
      loader:                 0,
      individualPermissionData: [],
    };
  }

  // ── Column definitions (unchanged logic, improved style) ──────────────
  articlecolumns = [
    { dataField: "sl_no",           text: "Sl No." },
    { dataField: "request_date",    text: "Date",         sort: true },
    { dataField: "request_message", text: "Comments" },
    { formatter: this.requestFunc.bind(this) },
    { dataField: "receiver_name",   text: "Receiver Name" },
    { dataField: "receiver_mobile", text: "Receiver Mobile" },
    {
      dataField: "Status",
      text:      "Status",
      formatter: this.performanceFunc.bind(this),
    },
    { formatter: this.iconFunc.bind(this) },
  ];

  // Eye icon / view button (unchanged logic)
  performanceFunc(val, row) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
        onClick={() => this.setState({ viewDetailsModal: true, individualPermissionData: row.individualPermissionData })}
      >
        <span style={{
          background:   THEME.primaryBg,
          color:        THEME.primary,
          border:       `1px solid ${THEME.primary}`,
          borderRadius: '8px',
          padding:      '4px 10px',
          fontSize:     '12px',
          fontWeight:   600,
          display:      'inline-flex',
          alignItems:   'center',
          gap:          '5px',
        }}>
          <i className="fas fa-eye" style={{ fontSize: '11px' }} /> View
        </span>
      </div>
    );
  }

  // Status icon — replaced with StatusBadge (unchanged logic)
  iconFunc(val, row) {
    const data = row.individualPermissionData;
    if (!data) return null;
    return <StatusBadge status={data.permission_status} />;
  }

  // College-requested marker (unchanged logic)
  requestFunc(val, row) {
    const data = row.individualPermissionData;
    if (data?.permission_request_type_id == 2) {
      return (
        <span style={{
          background:   'rgba(139,92,246,0.10)',
          color:        '#7C3AED',
          padding:      '3px 10px',
          borderRadius: '12px',
          fontSize:     '11px',
          fontWeight:   600,
          display:      'inline-flex',
          alignItems:   'center',
          gap:          '4px',
        }}>
          <i className="fas fa-star" style={{ fontSize: '10px' }} /> By College
        </span>
      );
    }
    return null;
  }

  render() {
    const parentPermission = this.props.parentPermission;
    const permissionRequest = this.props.permissionRequest;

    if (parentPermission.loading || permissionRequest.loading) return null;

    if (parentPermission.error !== undefined) {
      alert("Server Error. " + parentPermission.error.message);
      return null;
    }
    if (permissionRequest.error !== undefined) {
      alert("Server Error. " + permissionRequest.error.message);
      return null;
    }

    // ── Data processing (unchanged logic) ──────────────────────────────────
    const studentData = this.props.stateData.studentData;
    const filter_data = parentPermission.getParentsPermissionDetails
      .filter(item => item.student_mobile == studentData.contact_no);

    const studentDetails = filter_data.map((item, index) => {
      const requestTitle   = item.request_title   || "";
      const requestMessage = item.request_message || "";
      let requestMessagePart = requestMessage;
      if (requestMessage && requestTitle) {
        requestMessagePart = `${requestTitle} - ${requestMessage}`;
      } else {
        requestMessagePart = requestTitle || requestMessage;
      }
      return {
        sl_no:                  index + 1,
        receiver_name:          item.receiver_name,
        receiver_mobile:        item.receiver_mobile,
        request_message:        requestMessagePart,
        request_date:           moment.unix(item.request_date).format("DD-MM-YYYY"),
        individualPermissionData: item,
      };
    });

    // ── Summary counts (unchanged logic) ──────────────────────────────────
    const students       = parentPermission.getParentsPermissionDetails;
    const overallrequest = students.length;
    const totalrequest   = students.filter(item => item.permission_status == null).length;
    const totalaccept    = students.filter(item => item.permission_status == "1").length;
    const totaldecline   = students.filter(item => item.permission_status == "2").length;

    return (
      <Container fluid style={{ paddingTop: '8px' }}>

        {/* ── Summary row ───────────────────────────────────────────── */}
        <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap' }}>
          <SummaryChip label="Total"    count={overallrequest} bg="rgba(91,95,239,0.10)"   color="#4338CA" />
          <SummaryChip label="Pending"  count={totalrequest}   bg="rgba(245,158,11,0.10)"  color="#B45309" />
          <SummaryChip label="Approved" count={totalaccept}    bg="rgba(16,185,129,0.10)"  color="#047857" />
          <SummaryChip label="Declined" count={totaldecline}   bg="rgba(239,68,68,0.10)"   color="#B91C1C" />
        </div>

        {/* ── Permission Table ──────────────────────────────────────── */}
        <SectionCard
          title="Permission Requests"
          iconClass="fas fa-shield-alt"
          headerBg={GRADIENTS.purple}
          bodyPadding="16px"
        >
          {this.state.loader === 1 && (
            <div style={{ textAlign: 'center', padding: '8px' }}>
              <span className="spinner-border spinner-border-sm" style={{ color: THEME.primary }} />
            </div>
          )}

          {filter_data.length > 0 ? (
            <CardLessDataTableWithOutSearch
              parentData={studentDetails}
              particlecolumns={this.articlecolumns}
              name="attendance"
            />
          ) : (
            <EmptyState message="No permission requests found" iconClass="fas fa-shield-alt" />
          )}
        </SectionCard>

        {/* Permission Details Modal (unchanged) */}
        <PermissionDetailsModal
          stateData={this.state}
          show={this.state.viewDetailsModal}
          onHide={() => this.setState({ viewDetailsModal: false })}
        />

      </Container>
    );
  }
}

// ─── Apollo HOC (unchanged) ───────────────────────────────────────────────────

export default withRouter(
  compose(
    graphql(FETCH_PARENT_PERMISSION, {
      options: () => ({
        variables:   { institute_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: 'cache-and-network',
      }),
      name: "parentPermission",
    }),
    graphql(FETCH_PERMISSION_REQUEST_TYPES, {
      options: () => ({
        variables:   { id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: 'cache-and-network',
      }),
      name: "permissionRequest",
    }),
  )(NAPermissionDetails)
);
